import IS_CLIENT_RENDERED from "./isClientRendered";

const intercom = {
  show: () => {
    if (IS_CLIENT_RENDERED) {
      window.Intercom("show");
    }
  },
};

export default intercom;



// WEBPACK FOOTER //
// ./src/util/intercom.js